import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { CardNew } from '@/components-new/CardNew/CardNew';
import { CardNewContent } from '@/components-new/CardNew/styles';
import { PlatformConnectionType } from '@/types/invoiceVaultTypes';
import { PreviewFrame } from '../../styles';

export const PayerPreview = ({ platform }: { platform: PlatformConnectionType | null }) => {
  const verify = platform?.default_mode === 'verify';
  const steps = [
    'Open the link or scan the QR',
    ...(verify ? ['Verify identity with TrustStamp'] : []),
    'Type the invoice number',
    'Accept the invoice or raise a dispute',
    'See bank instructions straight from your vault',
  ];

  return (
    <CardNew>
      <CardNewContent>
        <Typography variant='subTitle'>What the payer sees</Typography>
        <PreviewFrame>
          <Typography variant='caption'>WireVault secure invoice</Typography>
          <Typography variant='bodySmall' fontWeight='medium'>
            Invoice from your organization
          </Typography>
          <Box as='ol' paddingLeft='18px' margin='0'>
            {steps.map((s) => (
              <li key={s}>
                <Typography variant='caption'>{s}</Typography>
              </li>
            ))}
          </Box>
          <Typography variant='caption'>
            {platform?.pay_through_wirevault
              ? 'They can also pay through WireVault.'
              : 'They pay from their own bank; the instructions are read-only.'}
          </Typography>
        </PreviewFrame>
      </CardNewContent>
    </CardNew>
  );
};
